
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-5'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            취소/환불 규정 관리
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              수정
            </button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 홈페이지 상품 상세페이지 하단에 공통적으로 노출되는 "취소/환불 규정" 입니다. </p>
            <p>2. 각 PC, 모바일 화면에 보이게 글자 및 이미지 업로드하면 됩니다. </p>
          </div>
        </div>

        <div class="Admin_PageDetailOnlyEditor">
          <div class="Admin_PageDetail_onlyEditor onlyEditorPC">
            <label for='editor_content'>PC 내용</label>
            <p>- PC 화면 가로 사이즈 : 800px (세로 사이즈 자유)</p>
            <custom-textarea
              v-model="formData.editorContent"
              :id="'editor_content'"
            />
          </div>
          <div class="Admin_PageDetail_onlyEditor onlyEditorMobile">
            <label for='editor_content_mobile'>모바일 내용</label>
            <p>- 모바일 화면 가로 사이즈 : 500px (세로 사이즈 자유)</p>
            <custom-textarea
              v-model="formData.editorContentMobile"
              :id="'editor_content_mobile'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'
import {
  get_editor_one,
  update_editor
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminCustomerManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea: CustomTextarea

  },
  setup () {
    return {
      formData: ref({
        editorContent: '',
        editorContentMobile: ''
      })
    }
  },
  methods: {
    check_form: function () {
      // 업로드 중인 이미지가 본문에서 누락되지 않도록 저장 전에 확인한다.
      if (!editorsReady(this)) return
      update_editor(
        '2',
        this.formData.editorContent,
        this.formData.editorContentMobile
      ).then(() => {
        alert('수정이 완료되었습니다.')
      })
    }
  },
  mounted () {
    get_editor_one('2').then((result) => {
      this.formData.editorContent = result[0].editor_content
      this.formData.editorContentMobile = result[0].editor_content_mobile
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminCancellationRefundPolicyManagement.vue